
import {SET_RECENT_BUILDINGS} from '../actions/recentBuildings';

const recentBuildings = (state = [], action) => {
    switch(action.type)
    {
        case SET_RECENT_BUILDINGS : 
        return action.payload
        default:
        return state;
    }
};

export default recentBuildings;


// WEBPACK FOOTER //
// ./src/store/reducers/recentBuildings.js